<template>
  <div id="in">
    <el-row>
      <div>
        <el-avatar
          class="md-head-pic"
          shape="circle"
          :size="90"
          src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
          @error="errorHandler"
        >
          <img :src="error_url" />
        </el-avatar>
      </div>
      <div class="user-name">
        <span>{{ myInfo.username }}，您好</span>
      </div>
      <div class="credit">
        <div>
          您的信用等级为：
        </div>
        <div class="star">
          <el-rate
            :max="5"
            :low-threshold="3"
            :high-threshold="4"
            allow-half
            v-model.number="myInfo.credit"
            :colors="['#d84019', '#2a9df7', '#ff9900']"
            @change="changeCredit(scope.row)"
            disabled
          >
          </el-rate>
          <div class="rate">
            <div v-if="myInfo.credit < 3">信誉不佳，无法购票！</div>
            <div v-else-if="myInfo.credit > 4">信用良好，请保持！</div>
            <div v-else>信用一般，请不要随意退票！</div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
  <div class="information">
    <div class="myinfotitle">
      我的信息
      <el-button
        type="primary"
        class="revise-btn"
        plain
        @click="handleEdit()"
        size="mini"
        >编辑</el-button
      >
      <el-button
        type="primary"
        class="vip-btn"
        plain
        @click="handleVip()"
        size="mini"
        >开通会员</el-button
      >
      <el-dialog
        v-model="dialogVisible"
        width="50%"
        :before-close="handleClose"
      >
        <div class="title2">请填写需要修改的信息</div>
        <!----------------->
        <el-form
          :model="resetMyInfo"
          label-width="70px"
          style="margin-left:-15px"
        >
          <el-form-item label="手机号">
            <el-input v-model="resetMyInfo.phone_num"></el-input>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="resetMyInfo.username"></el-input>
          </el-form-item>
        </el-form>
        <!-------------------->
        <template #footer>
          <span class="dialog-footer">
            <el-button class="btn-dia" @click="get">修改电话</el-button>
            <el-button class="btn-dia" @click="get2" style="width:150px"
              >修改用户名</el-button
            >
          </span>
        </template>
      </el-dialog>
      <el-dialog v-model="Visible" width="50%" :before-close="handleClose">
        <div class="title2">请选择开通时间</div>
        <!----------------->
        <el-form :model="form" label-width="200px">
          <el-form-item label="请选择开通时间：">
            <el-col :span="16">
              <el-select v-model="form.region" placeholder="时间">
                <el-option label="一个月" value="1"></el-option>
                <el-option label="两个月" value="2"></el-option>
                <el-option label="三个月" value="3"></el-option>
              </el-select>
            </el-col>
            <el-col :span="1">&nbsp;&nbsp;&nbsp; </el-col>
          </el-form-item>
          <el-form-item label="金额：" class="lab">
            <el-col :span="11">
              <div v-if="form.region.toString() == '1'">
                10元
              </div>
              <div v-else-if="form.region.toString() == '2'">
                18元
              </div>
              <div v-else-if="form.region.toString() == '3'">
                26元
              </div>
            </el-col>
          </el-form-item>
          <div class="paytit">
            <el-col :span="13">
              <div class="pay">
                <img class="tit" :src="aliPic" />
              </div>
            </el-col>
            <el-col :span="8"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-col
            >
            <el-col :span="11">
              <div class="pay">
                <img class="tit" :src="wechatPic" />
              </div>
            </el-col>
          </div>
          <div class="pic">
            <el-col :span="13">
              <div class="pay">
                <img :src="imgUrl" />
              </div>
            </el-col>
            <el-col :span="8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-col>
            <el-col :span="11">
              <div class="pay">
                <img :src="wechatImgUrl" />
              </div>
            </el-col>
          </div>
        </el-form>
        <!-------------------->
        <template #footer>
          <span class="dialog-footer">
            <el-button class="btn" @click="turnVip()" style="width:130px"
              >确认开通</el-button
            >
          </span>
        </template>
      </el-dialog>
    </div>
    <el-divider id="bottom-divider"></el-divider>
    <el-descriptions>
      <el-descriptions-item label="用户ID:"
        ><span>{{ myInfo.id }}</span></el-descriptions-item
      >
      <el-descriptions-item label="手机号:"
        ><span>{{ myInfo.phone_num }}</span></el-descriptions-item
      >
      <el-descriptions-item label="是否为vip:"
        ><span>{{ myInfo.vip }}</span></el-descriptions-item
      >
      <el-descriptions-item label="用户名:"
        ><span>{{ myInfo.username }}</span></el-descriptions-item
      >
      <el-descriptions-item label="信用值:"
        ><span>{{ myInfo.credit / 20 }}</span></el-descriptions-item
      >
    </el-descriptions>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  reactive,
  provide,
  watch,
  onMounted,
  getCurrentInstance,
  inject,
} from 'vue';
import { MyInfo } from '@/utils/api/myInfo';
import { Order } from '@/utils/api/order';
import { FlightService } from '@/utils/api/flight';
export default defineComponent({
  name: 'Middle',
  setup() {
    const dialogVisible = ref(false);
    const visible = ref(false);
    const VIPID = ref({ vipTime: '2021' });
    const form = ref({
      region: '',
    });
    const turnVip = () => {
      if (form.region == 1) VIPID.value.vipTime = '30';
      else if (form.region == 2) VIPID.value.vipTime = '60';
      else if (form.region == 3) VIPID.value.vipTime = '90';
      if (form.value.region.length == 0)
        ctx.$message({
          type: 'warning',
          message: '请选择时间',
        });
      else {
        MyInfo.turnVip(VIPID.value).then((res) => {
          if (res.status === 200) {
            ctx.$message({
              type: 'success',
              message: '开通成功',
            });
            myInfo.value.vip = '是';
          }
        });
      }
    };
    const myInfo = reactive({
      id: '',
      username: '',
      vip: '',
      credit: '',
      phone_num: '',
    });
    const resetMyInfo = reactive({
      username: '',
      phone_num: '',
    });
    onMounted(() => {
      requestTry();
    });
    const ID = ref({ num: '', newUsername: '' });
    const { ctx } = getCurrentInstance();
    const get = () => {
      ID.value.num = resetMyInfo.phone_num;
      MyInfo.resetPhone(ID.value).then((res) => {
        console.log(ID.value.num.length);
        let r = /^\d{11}$/;
        if (ID.value.num.length === 0)
          ctx.$message({
            type: 'warning',
            message: '请输入电话号码',
          });
        else if (!r.test(ID.value.num)) {
          ctx.$message({
            type: 'warning',
            message: '手机号应该为11位数字',
          });
        } else if (res.status === 200) {
          ctx.$message({
            type: 'success',
            message: '修改电话成功',
          });
          myInfo.value.phone_num = ID.value.num;
        }
      });
    };
    const reload = inject('reload');
    const get2 = () => {
      ID.value.newUsername = resetMyInfo.username;
      console.log(ID.value.newUsername);
      MyInfo.changeName(ID.value).then((res) => {
        let r = /^[\u4E00-\u9FFF]{2,6}$/;
        if (ID.value.newUsername.length === 0)
          ctx.$message({
            type: 'warning',
            message: '请输入用户名',
          });
        else if (!r.test(ID.value.newUsername))
          ctx.$message({
            type: 'warning',
            message: '用户名为2-6个汉字',
          });
        else if (res.status === 200) {
          ctx.$message({
            type: 'success',
            message: '修改用户名成功',
          });
          myInfo.value.username = ID.value.newUsername;
        }
      });
    };
    const requestTry = () => {
      MyInfo.searchMyInfo()
        .then((res) => {
          console.log(res.status);
          if (res.status === 200) {
            console.log(res);
            myInfo.id = res.data[3];
            resetMyInfo.username = res.data[0];

            myInfo.phone_num = res.data[1];
            resetMyInfo.phone_num = res.data[1];

            myInfo.vip = res.data[4];
            myInfo.username = res.data[0];
            myInfo.credit = res.data[2];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    const handleEdit = () => {
      console.log(dialogVisible.value);
      dialogVisible.value = true;
      console.log(dialogVisible.value);
    };
    const handleVip = () => {
      if (myInfo.vip === '是')
        ctx.$message({
          type: 'warning',
          message: '您已开通VIP',
        });
      else visible.value = true;
    };
    return {
      form,
      VIPID,
      turnVip,
      Visible: visible,
      handleVip,
      get2,
      requestTry,
      get,
      myInfo,
      dialogVisible,
      handleEdit,
      resetMyInfo,
      aliPic: require('@/assets/img/aliPay.png'),
      wechatPic: require('@/assets/img/wechatPay.png'),
      imgUrl: require('@/assets/img/aliPayCode.png'),
      wechatImgUrl: require('@/assets/img/wechatPayCode.png'),
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/css/config.scss';
.information {
  margin-top: 50px;
  margin-left: 50px;
  padding-top: 20px;
  padding-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  color: rgb(90, 165, 240);

  :deep(.el-dialog) {
    margin-top: 100px !important;
    text-align: center;
    width: 500px !important;
    padding-bottom: 60px;

    .el-dialog__footer {
      height: 20px;
      line-height: 20px;
    }
  }
}
.myinfotitle {
  height: 30px;
  line-height: 30px;
  padding: 0 30px;
  text-align: center;
  span {
    margin-left: 30px;
    font-size: 25px;
    font-weight: 500;
    color: rgb(70, 109, 161);
  }
}
#bottom-divider {
  height: 0.07px;
  line-height: 0.07px;
  width: 680px;
  margin-left: 60px;
}
.el-descriptions {
  margin-top: 20px;
  padding-left: 60px;
  padding-right: 60px;
  padding-bottom: 10px;

  :deep(.el-descriptions) {
    .el-descriptions__label {
      // height: 20px;
      // line-height: 20px;
      font-size: 50px;
    }
  }
}
#in {
  margin-top: 40px;
  width: 100%;
  height: 130px;
  line-height: 130px;
  background-color: rgb(251, 251, 251);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 1vh 1vw;
  div {
    float: left;
    margin-left: 10px;
  }
}
.user-name {
  padding-left: 15px;
  font-size: 23px;
  font-weight: 500;
}
.credit {
  position: absolute;
  left: 340px;
  margin-left: 60px !important;
  width: 500px;
  .star {
    margin-top: 55px;
    width: 300px !important;
    .rate {
      font-size: 14px;
      color: #999;
      position: relative;
      top: -30px;
      left: 10px;
      width: 220px;
    }
  }
  div {
    margin-right: 10px;
  }
}
.md-head-pic {
  vertical-align: middle;
}
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 18px;
}
.box-card {
  width: 480px;
}
.title2 {
  color: rgb(70, 109, 161);
  font-size: 20px;
  margin-bottom: 100px;
  height: 10px;
  line-height: 10px;
}
.btn {
  height: 20px;
  width: 80px;
  background-color: #3c5d89;
  color: white;
  font-weight: 600;
  float: right;
  margin-top: 5px;
}
.btn-dia {
  height: 20px;
  width: 100px;
  margin-left: 50px;
  background-color: #3c5d89;
  color: white;
  font-weight: 600;
}
.el-button--primary {
  height: 30px;
  width: 60px;
  background-color: #3c5d89;
  color: white;
  font-size: 16px;
  font-weight: 500;
}
.revise-btn {
  margin-left: 400px;
  width: 90px;
}
.vip-btn {
  height: 30px;
  width: 90px;
  background-color: $themeRed;
  color: white;
  font-size: 16px;
  font-weight: 500;
  margin-left: 10px;
}

img {
  width: 150px;
  height: 150px;
}
.pic {
  height: 150px;
  padding-left: 50px;
}
.tit {
  height: 30px;
  width: 130px;
}
.paytit {
  margin-left: 50px;
}
</style>
